import React from "react";

import LogoPath from "@images/logo_slogan_blue.svg";

import Image from "@/components/common/image";

import "./styles.scss";

const LandingFooter = () =>
  (
    <footer className="landing-footer">
      <Image src={LogoPath} className="landing-footer__logo" alt="Lunaro" width={128} height={24} />
      <p>
        © Lunaro.ru,
        {" "}
        {new Date().getFullYear()}
      </p>
    </footer>
  );

export default LandingFooter;
